/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * FR API Documentation
 * OpenAPI spec version: 1
 */

export type GetPublicInspectionDocumentsFormatConditionsSpecialFiling = typeof GetPublicInspectionDocumentsFormatConditionsSpecialFiling[keyof typeof GetPublicInspectionDocumentsFormatConditionsSpecialFiling];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPublicInspectionDocumentsFormatConditionsSpecialFiling = {
  NUMBER_0: 0,
  NUMBER_1: 1,
} as const;
